import axios from 'axios'
import * as types from '../mutation-types'
import QuestionsService from '~/services/questions';

// state
export const state = {
  questions: [],
  question: null,
};

// getters
export const getters = {
  questions: state => state.questions,
  question: state => state.question,
  testQuestions: state => state.testQuestions,
};

// mutations
export const mutations = {
  [types.QUESTIONS_FETCH_ALL] (state, questions) {
    state.questions = questions
  },
  [types.QUESTIONS_FIND] (state, question) {
    state.question = question
  },
  [types.QUESTIONS_CLEAR] (state) {
    state.question = null
  },
  [types.QUESTIONS_CREATE] (state, question) {
    if (!state.questions) {
      state.questions = [];
    }
    state.questions.push(question);
  },
  [types.QUESTIONS_REMOVE] (state, questionId) {
    state.questions.splice(state.questions.findIndex(el => el.id === questionId), 1);
  },
  [types.QUESTIONS_UPDATE] (state, question) {
    let index = state.questions.findIndex(el => el.id === question.id);
    if (index !== -1) {
      state.questions[index] = question;
    }
  },
};

// actions
export const actions = {

  async fetchTestQuestions ({ commit }, testId) {
    const questions = await QuestionsService.fetchTestQuestions(testId);
    commit(types.QUESTIONS_FETCH_ALL, questions);
  },
  async fetchTestQuestionsFull ({ commit }, testId) {
    const tests = await QuestionsService.fetchTestQuestionsFull(testId);
    commit(types.QUESTIONS_FETCH_ALL, tests);
  },
  async fetchFullTestQuestions ({ commit }, testId) {
    const tests = await QuestionsService.fetchTestQuestionsFull(testId);
    commit(types.QUESTIONS_FETCH_ALL, tests);
  },
  clearQuestion ({ commit }) {
    commit(types.QUESTIONS_CLEAR);
  },
  async find ({ commit }, questionId) {
    const test = await QuestionsService.getQuestion(questionId);
    commit(types.QUESTIONS_FIND, test);
  },
  async findFull ({ commit }, questionId) {
    const test = await QuestionsService.getQuestionFull(questionId);
    commit(types.QUESTIONS_FIND, test);
  },
  async create ({ commit }, form) {
    const test = await QuestionsService.createQuestion(form);
    commit(types.QUESTIONS_CREATE, test);
  },
  async update ({ commit }, form) {
    const test = await QuestionsService.updateQuestion(form);
    commit(types.QUESTIONS_UPDATE, test);
  },
  async remove ({ commit }, questionId) {
    await QuestionsService.removeQuestion(questionId);
    commit(types.QUESTIONS_REMOVE, questionId);
  },
};
